/**
 * Zvuky do dílny. Přehráváme přes Web Audio, ne přes <audio> — kontext se dá
 * založit hned při skenování (tedy v reakci na akci uživatele) a zvuk se do něj
 * jen naplánuje na později. Obyčejné `play()` po třech vteřinách by prohlížeč
 * mohl zablokovat jako autoplay.
 */

type WebkitWindow = Window & { webkitAudioContext?: typeof AudioContext };

/** Cinknutí penízků po ukončení zakázky. */
const COINS_URL = '/sounds/penizky.m4a';

/** Stažený soubor držíme v paměti, ať se v okamžiku přehrání na nic nečeká. */
let coinsData: Promise<ArrayBuffer> | null = null;

/** Předstáhne zvuk — volej při otevření obrazovky. */
export function prefetchCoins(): Promise<ArrayBuffer> {
  if (!coinsData) {
    const p = fetch(COINS_URL).then(async (r) => {
      if (!r.ok) throw new Error(`Zvuk se nepodařilo stáhnout (${r.status})`);
      // Typy fetch připouštějí i ArrayBufferView, prakticky vrací ArrayBuffer.
      return (await r.arrayBuffer()) as ArrayBuffer;
    });
    // Bez tohohle by neúspěšné stažení skončilo jako unhandled rejection.
    p.catch(() => {});
    coinsData = p;
  }
  return coinsData;
}

/**
 * Přehraje cinknutí penízků za `delaySec` vteřin. Zvuk je třešnička — když ho
 * prohlížeč nepustí (ztlumený tablet, zakázané audio), tiše se to přeskočí.
 */
export function playCoins(delaySec = 0): void {
  const Ctx = window.AudioContext ?? (window as WebkitWindow).webkitAudioContext;
  if (!Ctx) return;
  let ctx: AudioContext;
  try {
    ctx = new Ctx();
  } catch {
    return;
  }
  const startedAt = ctx.currentTime;
  prefetchCoins()
    // decodeAudioData si data „sní", proto kopie — ať jde zvuk přehrát znovu.
    .then((buf) => ctx.decodeAudioData(buf.slice(0)))
    .then((audio) => {
      const src = ctx.createBufferSource();
      src.buffer = audio;
      src.connect(ctx.destination);
      // Odpočítáváme od chvíle volání, ne od dokončení dekódování.
      src.start(Math.max(ctx.currentTime, startedAt + delaySec));
      src.onended = () => {
        ctx.close().catch(() => {});
      };
    })
    .catch(() => {
      ctx.close().catch(() => {});
    });
}
